import LangEnum from '../../../../../../lang/LangEnum';
import { DefaultFilters } from '../../../../../../services/modules/userContextPreferences/userContextPreferences.types';
import useDateRangeDefaultFilter from '../../../../../Crud/filters/hooks/dateRangeFilter/useDateRangeDefaultFilter';
import useDateRangeFilter from '../../../../../Crud/filters/hooks/dateRangeFilter/useDateRangeFilter';
import {
  FilterOptionV3,
  PossibleFilters,
  ReturnTypeOfUseDateRangeFilter,
} from '../../../../../Crud/filters/sharedBetweenFilters/types';
import { DateShortcut } from '../../dateRangeFilter.types';

interface IDateFilterRangeProps {
  defaultFilters: DefaultFilters | null;
  shouldIgnoreDefaultFilters?: boolean;
  title: string;
  toHide?: boolean;
  groupBy?: LangEnum;
  initialDateLabel?: LangEnum;
  filtersKey: {
    startDateKey: string;
    endDateKey: string;
    shortcutKey?: string;
    shortcutStepKey?: string;
  };
  fixed?: boolean;
  systemDefaultShortcut?: DateShortcut;
}

type DateRangeFilterOutput = FilterOptionV3 & {
  dateRangeArgs: ReturnTypeOfUseDateRangeFilter;
};

const useDateRangeFilterWithDefaultValues = ({
  defaultFilters,
  title,
  toHide,
  shouldIgnoreDefaultFilters = true,
  groupBy = LangEnum.GLOBAL_ORDER,
  initialDateLabel,
  filtersKey: { endDateKey, startDateKey, shortcutKey, shortcutStepKey },
  fixed = true,
  systemDefaultShortcut,
}: IDateFilterRangeProps): DateRangeFilterOutput => {
  const {
    finalDateDefaultValue,
    initialDateDefaultValue,
    shortcutDefaultValue,
    shortcutStepDefaultValue,
  } = useDateRangeDefaultFilter({
    startDateKey,
    endDateKey,
    defaultFilters,
    shortcutKey: shortcutKey ?? DateShortcut.QUARTER,
    shortcutStepKey: shortcutStepKey ?? DateShortcut.QUARTER,
    systemDefaultShortcut,
  });

  const {
    cleanFilter: cleanCreationDateFilter,
    getSearchParamKeys: getSearchParamKeysOfCreationDateFilter,
    ...creationDateFilter
  } = useDateRangeFilter({
    initialDateKey: startDateKey,
    finalDateKey: endDateKey,
    initialDateLabel,

    initialDateDefaultValue: initialDateDefaultValue as string,
    finalDateDefaultValue: finalDateDefaultValue as string,

    shouldIgnoreDefaultFilters,
    shortcutDefaultValue: shortcutDefaultValue as DateShortcut,
    shortcutStepDefaultValue: shortcutStepDefaultValue as DateShortcut,
  });

  return {
    type: PossibleFilters.DATE_RANGE,
    title,
    dateRangeArgs: creationDateFilter,
    cleanFilter: cleanCreationDateFilter,
    getSearchParamKeys: getSearchParamKeysOfCreationDateFilter,
    groupBy,
    fixed: fixed,
    toHide,
  };
};

export default useDateRangeFilterWithDefaultValues;
